







import { defineComponent, SetupContext } from '@vue/composition-api';
import { provideStore } from '@/components/composables/useStore';
import UpdateAlert from '@/components/utils/UpdateAlert.vue';

const Component = defineComponent({
  name: 'App',

  components: {
    UpdateAlert,
  },

  setup(_, { root: { $store } }: SetupContext) {
    provideStore($store);
  },
});
export default Component;
